@if (companyInitials$ | async; as companyInitials) {
  <button
    class="smartlook-hide"
    [disabled]="disabled"
    [class.disabled]="disabled"
    (click)="goToChangeCompany()">
      {{ companyInitials }}
  </button>
}
